import ErrorPage from "components/errors/ErrorPage";
import type { ReactNode } from "react";

function ServerErrorPage(): ReactNode {
  return <ErrorPage title="500" />;
}

export default ServerErrorPage;
